import * as subcategories from './list'

export const allSubcategories = Object.values(subcategories).sort(
    (previous, current) => previous.priority - current.priority,
)
